export const LeafIcon = ({ className }: { className?: string }) => (
  <svg viewBox="0 0 24 33" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path
      d="M22 32c0-5.787-1.52-10.007-11-17m3.118 12C4.7 27 1 20.05 1 14.008 1 7.966 4.78 1 4.78 1a11.126 11.126 0 003.635 4.77 14.164 14.164 0 005.557 2.659C23.13 10.723 23 14.009 23 17.706"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
